import { useAxios } from "@wayflyer/auth-sdk";
import { useAnalyticsContext } from "shared-utils";
import { useCallback, useState } from "react";
import { useErrorModal, analytics } from "shared-ui";

export type UseSubmitAccountsProps = {
  submitAccountsPath: string;
  onAccountsSubmitted?: () => void;
};

/**
 *
 * Small hook that encapsulates the logic for hitting the "finalise-connected-accounts" endpoint.
 * i.e. the request we make when a user is "Done" connecting their bank accounts or emailing us statements.
 */
export function useSubmitAccounts({ submitAccountsPath, onAccountsSubmitted }: UseSubmitAccountsProps) {
  const [submittingAccounts, setSubmittingAccounts] = useState(false);
  const analyticsContext = useAnalyticsContext();
  const { openErrorModal } = useErrorModal();
  const client = useAxios();

  const submitAccounts = useCallback(
    async ({ source }: any) => {
      if (!submittingAccounts) {
        setSubmittingAccounts(true);
        try {
          await client.post(submitAccountsPath, { emailBankStatements: source === "email" });
          await analytics.bankStatementsDone(analyticsContext, source);
        } catch (error) {
          openErrorModal({ variant: "submit-error", error });
        } finally {
          setSubmittingAccounts(false);
          onAccountsSubmitted && onAccountsSubmitted();
        }
      }
    },
    [submittingAccounts, submitAccountsPath, client, analyticsContext, openErrorModal, onAccountsSubmitted]
  );

  return { submitAccounts, submittingAccounts };
}
